module.exports = {
  common: {
    message: '數據錯誤',
    toast: '請填寫完整信息'
  },
  vantText: {
    confirm: '確認',
    cancel: '取消',
  },
  MealNum: {
    title: "店名",
    lang: "選擇語言",
    chooseLang: '請選擇語言',
    mealNum: "人數",
    seat: '入座',
    text: '請選擇人數'
  },
  ShopInfo: {
    title: "店鋪詳情",
    name: "名稱",
    address: "地址",
    phone: "電話",
    time: "營業時間",
    intro: "介紹",
  },
  OrderDetail: {
    uploadVoucher: "上传憑證",
    accountInformation: "戶口信息",
    title: "訂單詳情",
    success: '下單成功',
    pay: '已支付',
    unpaid: '未支付',
    totalNum: '總人數',
    status0: "準備中",
    status1: "製作中",
    status2: "製作完",
    status3: "已上菜",
    status4: "已送達",
    status5: "已退菜",
    time: '下單時間',
    orderNum: '訂單編號',
    back: '返回',
    containerOrder: '繼續下單',
    goPay: '去支付',
    loading: '加載中...',
    cashPay: '請至櫃檯結賬',
    subtitle: "提交訂單",
    needPay: "應收金額",
    pricePay: "金額",
    toPay: "待支付",
    ticket: "訂單碼",
    ticketTip: '請將頁面截圖保存，到店顯示訂單碼，謝謝！',
    addressMoney: '地區附加金額',
    voucherTip: "請上傳憑證圖片！",
    message: '數據錯誤',
    continue: "繼續選擇",
    submit: "下單",
    confirm: '確認',

    view: '查看訂單',
    checkOrder: '查看訂單',
    orderStatus: '訂單狀態',
    order0: '支付成功',
    order1: '支付失敗',
    order2: '支付取消',
    returnOrder: '返回訂單',
    newOrder: '重新下單',
    againOrder: '再來一單',
    noPayOrder: '訂單已經超時未付款，請重新下單',
    plsPay: '請先確認已經付款',

    prompt: '請到櫃檯結帳',
    CounterTitle: '成功',
  },
  Dishes: {
    title: '請選擇',
    orderDetail: ' 訂單詳情',
    name: '菜單',
    nonefood: '暫無產品',
    cart: '購物車',
    order: '下單',
    package: "套餐",
    del: '刪除',
    isDel: '當前產品數量為1，是否移出購物車',
    addfood: '請先添加產品',
    none: '無',
    continueOrder: '繼續點單'
  },
  PackageDetail: {
    title: "詳情",
    chooseSpecs: '選份量',
    note: '口味/備註',
    remark: '備註',
    inputRemark: "請輸入備註",
    certain: '確定',
    addToCart: '加入購物車',
  },
  Home: {
    shopName: '店鋪名稱：',
    address: '店鋪地址：',
    intro: "店鋪介紹：",
    phone: "店鋪電話：",
    startTime: "開店時間：",
    endTime: "關門時間：",
    bookBtn: '預約',
    takeawayBtn: '點單',
    menuBtn: '菜單',
    pickup: '打包',
    packNumber: '打包號',
    p: '本服務使用便捷點餐系統',
    more: '點擊了解更多',
  },
  InputInfo: {
    paymentVoucher: '支付憑證',
    title: "預訂",
    name: '姓名',
    inputName: '輸入姓名',
    phone: '手機號碼',
    inputPhone: "請輸入手機號碼",
    maelNum: '人數',
    inputMealNum: "請輸入人數",
    gender: "性別",
    woman: '女',
    man: '男',
    bookdate: "預訂日期",
    bookMealTime: "預訂時間",
    submit: '提交',
    address: '收貨地址',
    inputAddress: '請輸入收貨地址',
    comment: '留言',
    deliveryTime: '交貨時間',
    deliveryDate: '交貨日期',
    PickUpDate: "取餐日期",
    PickUpTime: "取餐時間",
    inputComment: '請輸入留言',
    inputDeliveryTime: "請輸入交貨時間",
    inputDeliveryDate: "請輸入交貨日期",
    inputPickUpTime: "请输入取餐時間",
    inputPickUpDate: "请输入取餐日期",
  },
  Result: {
    title: '預訂詳情',
    success: '預訂成功',
    name: '姓名',
    phone: '電話號碼',
    mealTime: '就餐時間',
    mealNum: '人數',
    people: '人'
  },
  ContactUs: {
    contact: '聯繫銷售人員',
    area: '地區',
    name: '姓名',
    phone: '電話',
    hongkong: '香港',
    taiwan: '台灣',
    zhuhai: '廣東珠海',
    shanwei: '廣東汕尾',
    shenzhen: '廣東深圳',
    shantou: '廣東汕頭',
    dongguan: '廣東東莞',
    guilin: '廣西桂林',
    fuzhou: '福建福州',
    lin: '林先生',
    tian: '佃先生',
    chen: '陳先生',
    chan: '陳先生',
    qiu: '邱先生',
    liu: '劉先生',
    wang: '王先生',
    shi: '施先生',
    misschen: '陳小姐'
  },
  PlaceOrderDetail: {
    floor: '樓層',
    tableNum: '桌號',
    outTime: '訂單超時',
    cooked: '菜已做完',
    overCook: '菜已上完',
    pay: '已支付',
    unpaied: '未支付',
    cancel: '已取消',
    time: '下單時間',
    oorderNum: '訂單編號',
    number: '入座人數',
    status0: '準備中',
    status1: '製作中',
    status2: '製作完',
    status3: '已上菜',
    status4: '已送達',
    status5: '已退菜',
    payMethod: '支付方式',
    cash: "現金",
    wechat: '微信',
    alipay: '支付寶',
    applePay: "Apple Pay",
    creditcard: "信用卡",
    orther: '其他',
    payMoney: '付款',
    clean: '清理桌面',
    message: '訂單還未結賬、不能清理。',
    print: '打印',
    orderDetail: '訂單詳情',
    orderList: '訂單列表',

    isServiceCharge: '是否開啓服務費',
    isDiscountFee: '是否開啓折扣費',
    discountCharge: '折扣費',

    turnTable: '轉桌',
    isTurnTable: '確定要轉桌？',
    turnTableErr: '該桌已有人，不能轉',
    confirmPay: '確認已支付',
  },
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/hk.js